import Swal from 'sweetalert2'
import 'sweetalert2/src/sweetalert2.scss'

export function addToCartSuccess() {
  Swal.fire({
    icon: 'success',
    toast: true,
    text: ` Produkti u shtua në shportë`,
    showConfirmButton: false,
    position: 'bottom',
    timer: 2000,
    width: '300px',
    customClass: {
      container: 'container-class',
      popup: 'popup-class',
      icon: 'icon-class',
      content: 'content-class',
      title: 'title-class',
    },
    animation: true,
  })
}
export function generalSuccess() {
  Swal.fire({
    icon: 'success',
    toast: true,
    text: 'Sukses',
    showConfirmButton: false,
    position: 'top',
    width: '250px',
    timer: 2000,
    customClass: {
      container: 'container-success',
      popup: 'popup-success',
      icon: 'icon-success',
      content: 'content-success',
      title: 'title-success',
    },
    animation: true,
  })
}

export function generalSuccessLogin() {
  Swal.fire({
    icon: 'success',
    toast: true,
    text: 'Ju u loguat me sukses',
    showConfirmButton: false,
    position: 'top',
    width: '300px',
    timer: 2000,
    customClass: {
      container: 'container-success',
      popup: 'popup-success',
      icon: 'icon-success',
      content: 'content-success',
      title: 'title-success',
    },
    animation: true,
  })
}

export function generalSuccessRegister() {
  Swal.fire({
    icon: 'success',
    toast: true,
    text: 'Ju u regjistruat me sukses',
    showConfirmButton: false,
    position: 'top',
    width: '300px',
    timer: 3000,
    customClass: {
      container: 'container-success',
      popup: 'popup-success',
      icon: 'icon-success',
      content: 'content-success',
      title: 'title-success',
    },
    animation: true,
  })
}

export function OrderSuccess() {
  Swal.fire({
    icon: 'success',
    toast: true,
    text: 'Porosia u dërgua me sukses',
    showConfirmButton: false,
    position: 'bottom',
    width: '500px',
    timer: 5000,
    customClass: {
      container: 'container-class',
      popup: 'popup-class',
      icon: 'icon-class',
      content: 'content-class',
      title: 'title-class',
    },
    animation: true,
  })
}

export function generalError() {
  Swal.fire({
    icon: 'error',
    toast: true,
    text: 'Ndodhi një gabim në sistem!',
    showConfirmButton: false,
    position: 'top',
    width: '400px',
    timer: 2000,
    customClass: {
      container: 'container-error',
      popup: 'popup-error',
      icon: 'icon-error',
      content: 'content-error',
      title: 'title-error',
    },
    animation: true,
  })
}
export function CredentialsError() {
  Swal.fire({
    icon: 'error',
    toast: true,
    text: 'Email ose Password Gabim !',
    showConfirmButton: false,
    position: 'top',
    width: '350px',
    timer: 3000,
    customClass: {
      container: 'container-error',
      popup: 'popup-error',
      icon: 'icon-error',
      content: 'content-error',
      title: 'title-error',
    },
    animation: true,
  })
}

export function addToFavoritesError() {
  Swal.fire({
    icon: 'error',
    toast: true,
    text: 'Ju lutem logohu ose regjistrohu për ta shtuar tek të preferuarat!',
    showConfirmButton: false,
    position: 'top',
    width: '650px',
    timer: 6000,
    customClass: {
      container: 'container-error',
      popup: 'popup-error',
      icon: 'icon-error',
      content: 'content-error',
      title: 'title-error',
    },
    animation: true,
  })
}

export function addToFavoritesSuccess() {
  Swal.fire({
    icon: 'success',
    toast: true,
    html: `<span>Produkti u shtua tek të preferuarat! <a style="text-decoration: underline; color: white" href="/profile/favorites"><b>Shiko Listën</b></a><a/></span>`,
    showConfirmButton: false,
    position: 'top',
    width: '550px',
    timer: 10000,
    customClass: {
      container: 'container-success',
      popup: 'popup-success',
      icon: 'icon-success',
      content: 'content-success',
      title: 'title-success',
    },
    animation: true,
  })
}

export function transferCreditsSuccess() {
  Swal.fire({
    icon: 'success',
    toast: true,
    text: 'Transferimi i krediteve u krye me sukses!',
    showConfirmButton: false,
    position: 'top',
    width: '500px',
    timer: 3000,
    customClass: {
      container: 'container-success',
      popup: 'popup-success',
      icon: 'icon-success',
      content: 'content-success',
      title: 'title-success',
    },
    animation: true,
  })
}

export function generalApiError(error: string) {
  Swal.fire({
    icon: 'error',
    toast: true,
    html: `<span style="margin-right: 5px; margin-left: 5px">${error}</span>`,
    showConfirmButton: false,
    position: 'top',
    width: 'auto',
    timer: 3000,
    customClass: {
      container: 'container-error',
      popup: 'popup-error',
      icon: 'icon-error',
      content: 'content-error',
      title: 'title-error',
    },
    animation: true,
  })
}

export function emptyCart() {
  Swal.fire({
    icon: 'error',
    toast: true,
    text: 'Ju Lutem shtoni të paktën një produkt në shportë',
    showConfirmButton: false,
    position: 'top',
    width: '500px',
    timer: 5000,
    customClass: {
      container: 'container-error',
      popup: 'popup-error',
      icon: 'icon-error',
      content: 'content-error',
      title: 'title-error',
    },
    animation: true,
  })
}

export function addressValidation() {
  Swal.fire({
    icon: 'error',
    toast: true,
    text: 'Adresa duhet të jetë mbi 5 karaktere !',
    showConfirmButton: false,
    position: 'top',
    width: '500px',
    timer: 5000,
    customClass: {
      container: 'container-error',
      popup: 'popup-error',
      icon: 'icon-error',
      content: 'content-error',
      title: 'title-error',
    },
    animation: true,
  })
}

export function confirmationPopup(successCallback: any = null) {
  Swal.fire({
    text: 'Ju lutem konfirmoni veprimin !',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#28a745',
    cancelButtonColor: '#dc3545',
    confirmButtonText: 'Konfirmo',
    cancelButtonText: 'Anullo',
  }).then((result) => {
    if (result.isConfirmed) {
      if (typeof successCallback === 'function') successCallback()
    }
  })
}
